module.exports = __webpack_public_path__ + "img/ico-ygh.25c7646e.png";